// noinspection JSXUnresolvedComponent

import { Link } from 'react-router-dom';
import { joinClassNames } from '../../Helpers/Functions';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MobileMenuNavItem = ({ item, setIsOpen }) => {
  const { t } = useTranslation();

  return (
    <Link
      to={item.path}
      onClick={() => setIsOpen(false)}
      className={joinClassNames(
        'group flex gap-x-3 rounded-md p-6 text-3xl font-semibold',
        item.current ? '' : 'text-gray-700'
      )}
    >
      <div
        className={`group-hover:bg-pdwhite rounded-md ${item.current ? 'border-pddarkblue bg-pddarkblue border-1' : 'border-pddarkblue bg-pdwhite border-1'}`}
      >
        <item.icon
          aria-hidden="true"
          className={joinClassNames(
            'size-14 shrink-0 p-2',
            item.current ? 'stroke-pdwhite fill-pddarkblue' : 'stroke-pddarkblue'
          )}
        />
      </div>
      <span className="text-pddarkblue self-center font-semibold lg:ml-2">{t(item.name)}</span>
    </Link>
  );
};
